import get, { has, set } from '@/utils/lodash-alternatives';

export default function interpolate(action, event, context) {
  if (!action.meta) {
    return {
      type: action.type,
      data: action.data,
    };
  }
  const newAction = {
    type: action.type,
    data: JSON.parse(JSON.stringify(action.data)),
  };
  const variables = {};
  if (
    !Array.isArray(action.meta.variables) &&
    typeof action.meta.variables === 'object'
  ) {
    Object.keys(action.meta.variables).forEach(variableName => {
      const variableSelector = action.meta.variables[variableName];
      const handleSelector = createSelectorHandler(value => {
        set(variables, variableName, value);
      });
      handleSelector(variableSelector);
    });
  }
  if (
    Array.isArray(action.meta.selectors) &&
    action.meta.selectors.length > 0
  ) {
    action.meta.selectors.forEach(metaSelector => {
      const metaSelectorPath = metaSelector
        .replace('$action.', '')
        .replace('$data', 'data');
      if (!has(action, metaSelectorPath)) {
        new Error(['Meta selector must start with $']);
      }
      const actionSelector = get(newAction, metaSelectorPath);
      const handleSelector = createSelectorHandler(value => {
        set(newAction, metaSelectorPath, value);
      });
      handleSelector(actionSelector);
    });
  }
  return newAction;

  function createSelectorHandler(update) {
    return function handleSelector(singleOrMultipleSelector) {
      if (Array.isArray(singleOrMultipleSelector)) {
        for (const selector of singleOrMultipleSelector) {
          const value = handleSingleSelector(selector);
          if (value !== undefined) {
            break;
          }
        }
      } else {
        handleSingleSelector(singleOrMultipleSelector);
      }
    };

    function handleSingleSelector(selector) {
      if (typeof selector === 'object') {
        return handleObjectSelector(selector);
      }
      if (typeof selector === 'string') {
        return handleStringSelector(selector);
      }
      return undefined;
    }

    function handleObjectSelector({ type, path = '', default: fallback }) {
      if (type !== undefined && type !== event.type) {
        update(undefined);
        return undefined;
      }
      let value = getValueBySelector(path);
      if (value === undefined) {
        value = fallback;
      }
      update(value);
      return value;
    }

    function handleStringSelector(selector) {
      const value = getValueBySelector(selector);
      update(value);
      return value;
    }

    function getValueBySelector(selector) {
      const selectorToQueryMap = {
        '$event.': path => (path === '' ? event : get(event, path)),
        '$action.': path => (path === '' ? action : get(action, path)),
        '$context.': path => (path === '' ? context : get(context, path)),
        '$variable.': path => (path === '' ? variables : get(variables, path)),
      };
      for (const prefix of Object.keys(selectorToQueryMap)) {
        if (selector.startsWith(prefix)) {
          const query = selectorToQueryMap[prefix];
          const path = selector.replace(prefix, '');
          return query(path);
        }
      }
      new Error(['Data selector must start with $']);
    }
  }
}
